import Validation from './validation'
import ValidationError from "./validation-error";

class ActiveCustomer extends Validation {
	constructor(drForm) {
		super();
		this.target = '.calc-email';
		this.selector = 'validate-active-customer';
		this.rule = 'isActiveCustomer';
		this.checker = 'validateActiveCustomer';
		this.init(drForm);
	}

	validate(email) {
		let responce = jQuery.post({
			url: dr.js_data.rest_api.forms.validate,
			async: false,
			data: {
				action: 'active_customer',
				email: email,
			}
		});
		if (responce.responseJSON.success !== true) {
			throw new ValidationError();
		}
		if (responce.responseJSON.result === false) {
			throw new ValidationError('You are not active customer, sorry!');
		}
		return true;
	}
}

export default ActiveCustomer;
